/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';

  /**
   * Коллекция для претензий по товарам.
   */
  app.Claims = app.ItemPageableCollection.extend({
    model: app.Claim,
    url: app.entryScriptName + '/api/v3/claim/?sort=-created_at',
    fetchCounter: 0,
    filter: 'null',
    isScroll: false,
    loadFilters: false,
    requestFilters: false,
    state: {
      firstPage: 1,
      pageSize: 20,
      order: 0,
    },
    defaults: {
      pageSize: 20,
      mode: 'server',
    },
  });
})();

}.call(window));